export const CLASS_OPTION_BUTTON = 'option-button';
